export const namespaced = true;

import TestPreparationPrintService from '@/services/TestPreparationPrintService.js';
import map from 'lodash/map';
import moment from 'moment-timezone';

export const state = {
  testPreparationPrints: [],
  selectedStudents: [],
};

export const mutations = {
  ADD_TEST_PREPARATION_PRINT(state, testPrint) {
    state.testPreparationPrints.push(testPrint);
  },
  DELETE_TEST_PREPARATION_PRINT_AT_INDEX(state, index) {
    state.testPreparationPrints.splice(index, 1);
  },
  CLEAR_TEST_PREPARATION_PRINTS(state) {
    state.testPreparationPrints = [];
  },
  SET_SELECTED_STUDENTS(state, students) {
    state.selectedStudents = students;
  },
  CLEAR_SELECTED_STUDENTS(state) {
    state.selectedStudents = [];
  },
};

export const actions = {
  addTestPreparationPrint({ commit }, testPrint) {
    commit('ADD_TEST_PREPARATION_PRINT', testPrint);
  },
  deleteTestPreparationPrint({ commit, state }, questionIndex) {
    const index = state.testPreparationPrints.findIndex((item) => item.questionIndex == questionIndex);
    commit('DELETE_TEST_PREPARATION_PRINT_AT_INDEX', index);
  },
  clearTestPreparationPrints({ commit }) {
    commit('CLEAR_TEST_PREPARATION_PRINTS');
  },
  finishSelectingStudents({ commit }, students) {
    commit('SET_SELECTED_STUDENTS', students);
  },
  clearSelectedStudents({ commit }) {
    commit('CLEAR_SELECTED_STUDENTS');
  },
  createPDF({ state }, pdfFormat) {
    let students = map(state.selectedStudents, (student) => {
      return {
        id: student.id,
        name: student.name,
      };
    });

    return buildAndDownloadPdf(state, students, pdfFormat);
  },
  createTemplatePdf({ state }) {
    let students = [
      {
        id: '',
        name: '',
      },
    ];

    return buildAndDownloadPdf(state, students, 'merge');
  },
};

export const getters = {
  getTestPreparationPrintById: (state) => (id) => {
    return state.testPreparationPrints.find((item) => item.id == id);
  },
  minNumOfQuestions() {
    // This is hardcode as min 3 questions
    return 3;
  },
  maxNumOfQuestions() {
    // This is hardcode as max 20 questions
    return 20;
  },
};

const buildAndDownloadPdf = (state, students, pdfFormat) => {
  let testPreparationPrints = map(state.testPreparationPrints, (test) => {
    return {
      bookId: test.book.id,
      bookPartId: test.bookPart.id,
      bookChapterId: test.bookChapter.id,
      bookBigQuestionId: test.bookBigQuestion.id,
      bookSmallQuestionSize: test.bookSmallQuestionSize,
    };
  });

  let formattedData = {
    format: pdfFormat,
    testPreparationPrints,
    students,
  };

  return TestPreparationPrintService.createPDF(formattedData).then((response) => {
    const blob = new Blob([response.data]);
    const fileName = `Test-preparation-${moment().format('X')}`; // format('X') is Unix Timestamp
    const fileExt = formattedData.format == 'merge' ? 'pdf' : 'zip';

    // Create a tag and trigger click to download url
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${fileName}.${fileExt}`;
    link.click();
  });
};
